module.exports = __webpack_public_path__ + "assets/img/role_smoll-036d31a9.gif";